import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/dev")({
  beforeLoad: ({ location }) => {
    const p = location.pathname.replace(/\/$/, "")
    if (p === "/dev") {
      throw redirect({ to: "/settings/dev/demos" })
    }
  },
  component: () => <Outlet />,
})
